 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		52: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		52: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "app/" + ({"1":"vendors~AssignmentsModalV2~AssignmentsV2~DirectShareWorksheets~Gift~KidFrame~KidFrameDetail~MemberHo~642b8b8b","2":"vendors~AssignmentsModalV2~AssignmentsV2~DirectShareWorksheets~KidFrame~KidFrameDetail~MemberHomepag~79c7a958","3":"AssignmentsModalV2~KidFrameDetail~MyStudents~RegistrationModal~SubmissionsReportPage~SwitchAccountMo~2ce4c6bf","4":"GradeFilteredContentCards~HomeLearning~InteractiveWorksheetsOverview~MyCollections~PredefinedCollect~cfdbee5b","7":"Checkout~Gift~UpdatePayment","8":"LandingPage~Pricing","9":"RegistrationModal","11":"AccountSettings","12":"AssignmentsModalV2","13":"AssignmentsV2","14":"BrainzyPaint","15":"Breadcrumbs","16":"Checkout","17":"DirectShareWorksheets","18":"FeaturedArtwork","19":"FillableWorksheet","20":"FirstTimeModal","21":"Gift","22":"GradeFilteredContentCards","23":"HomeLearning","24":"InteractiveWorksheetsOverview","25":"KidFrame","26":"KidFrameDetail","27":"LandingPage","28":"MemberHomepage","29":"MyAssignments","30":"MyCollections","31":"MyStudents","32":"Onboarding","33":"PracticeSkill","34":"PredefinedCollectionsDetail","35":"Pricing","36":"ProgressTracker","37":"RecaptchaV3","38":"RelatedGuidedLesson","39":"Reviews","40":"SeasonalDaysDropdown","41":"Sellpage","42":"SubPlansList","43":"SubmissionsReportPage","44":"SwitchAccountModal","45":"TopNav","46":"TopNavV1","47":"UpdatePayment","48":"UserMenu","49":"UserMenuV1","50":"vendors~Gift"}[chunkId]||chunkId) + "." + {"0":"04e0e2523549cdb23e75","1":"ba2eaa8b3e795f7d8468","2":"894343dd022dcd8b654f","3":"0f72a97d2cdd77245e0f","4":"aa3858ee2409109aafe0","5":"65f74d2095566b8cffb2","6":"65bbc0f3a496d943a586","7":"dac9c368e6cae80e87e8","8":"37efb420d788f16cacbd","9":"c13eeb7f2c04d08e9ceb","10":"7fb91cc0b9b73efbc48c","11":"0a400cc879688266eada","12":"b9181e171808495524fc","13":"7c4a0f991f82bbc617ce","14":"05e43c9c025c00dd045f","15":"9eb8eac127017c61b35c","16":"1060bcf57083f989a810","17":"ea5c0e82c78d03ba58b2","18":"5b01dfdca7eb8d6c4579","19":"4b95567e59e24a701cf8","20":"263a3238bd766e712c32","21":"4481325895d70fc5d792","22":"504802aa5f5c29a67347","23":"362c108a2705d920cbe0","24":"ce75ac923093f584cb33","25":"b13e9df6cfbe87e7b43a","26":"a9d99d7d9197edaedb9b","27":"9356f37c8681b7573787","28":"c38a0bac9c583de8a3b3","29":"a650b265e7678752b7c7","30":"6315d1967fc0b314840b","31":"0145cc91467ff0843e26","32":"6d5d87fd862b7c0d7c75","33":"319d0c6922513978dee0","34":"ec1765383fd9d7f04bd8","35":"e3ddd39e43929f237149","36":"015a799b35fd04de40a5","37":"e5f592372cc514d89a66","38":"c5ec5ea676c71d724a05","39":"109b55735672218da9a2","40":"ae434ec7843c00359217","41":"2e97bceecb22b5fd5a4b","42":"ccd5e2350e319f2d2591","43":"e2477ec5e69a281c8b17","44":"af0c2ecec93daf5266f5","45":"e04eaab7c1067b1f9799","46":"f8de87dbdcec1d3103e1","47":"354b1b5d146051d9eade","48":"9ae17b9744ffaf6c45a0","49":"56b8e5c4b41eafab5231","50":"f85ca56e3030cd795564","51":"e9673283d9b8054790d1","54":"0f5a13b0b546fe04f1cf","55":"8271b56401461bd0f227","56":"b86df1b5c2a0f5875308","57":"8645706964c41673e6f9"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"3":1,"7":1,"8":1,"9":1,"11":1,"12":1,"13":1,"15":1,"16":1,"17":1,"18":1,"20":1,"21":1,"22":1,"23":1,"24":1,"25":1,"26":1,"28":1,"29":1,"30":1,"31":1,"32":1,"33":1,"35":1,"39":1,"40":1,"41":1,"43":1,"45":1,"46":1,"47":1,"48":1,"49":1,"50":1,"54":1,"55":1,"56":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "app/" + ({"1":"vendors~AssignmentsModalV2~AssignmentsV2~DirectShareWorksheets~Gift~KidFrame~KidFrameDetail~MemberHo~642b8b8b","2":"vendors~AssignmentsModalV2~AssignmentsV2~DirectShareWorksheets~KidFrame~KidFrameDetail~MemberHomepag~79c7a958","3":"AssignmentsModalV2~KidFrameDetail~MyStudents~RegistrationModal~SubmissionsReportPage~SwitchAccountMo~2ce4c6bf","4":"GradeFilteredContentCards~HomeLearning~InteractiveWorksheetsOverview~MyCollections~PredefinedCollect~cfdbee5b","7":"Checkout~Gift~UpdatePayment","8":"LandingPage~Pricing","9":"RegistrationModal","11":"AccountSettings","12":"AssignmentsModalV2","13":"AssignmentsV2","14":"BrainzyPaint","15":"Breadcrumbs","16":"Checkout","17":"DirectShareWorksheets","18":"FeaturedArtwork","19":"FillableWorksheet","20":"FirstTimeModal","21":"Gift","22":"GradeFilteredContentCards","23":"HomeLearning","24":"InteractiveWorksheetsOverview","25":"KidFrame","26":"KidFrameDetail","27":"LandingPage","28":"MemberHomepage","29":"MyAssignments","30":"MyCollections","31":"MyStudents","32":"Onboarding","33":"PracticeSkill","34":"PredefinedCollectionsDetail","35":"Pricing","36":"ProgressTracker","37":"RecaptchaV3","38":"RelatedGuidedLesson","39":"Reviews","40":"SeasonalDaysDropdown","41":"Sellpage","42":"SubPlansList","43":"SubmissionsReportPage","44":"SwitchAccountModal","45":"TopNav","46":"TopNavV1","47":"UpdatePayment","48":"UserMenu","49":"UserMenuV1","50":"vendors~Gift"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"cb30306a496b38be9101","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"50d1d200d8f5c392c7cc","8":"2b436e69b3b155a4a770","9":"9a49e2f91f89f2ae59e4","10":"31d6cfe0d16ae931b73c","11":"4ad35bb3dca41c2cae0b","12":"18cf991620b959a27ab5","13":"b734186959164e388bc8","14":"31d6cfe0d16ae931b73c","15":"6e985076f7e07e2be13f","16":"2087248043751533f11c","17":"ea57ecccc391419a0e2a","18":"d56d9288e4c0c7368f48","19":"31d6cfe0d16ae931b73c","20":"690a68dfe2a08fd2cff3","21":"0b35e6aabb2384d8e4d5","22":"cc59a2d5075b55748ffc","23":"4c89bea8f7f35505c32a","24":"da18f98999ae97bf95a3","25":"dd19b504cc34caeecb9d","26":"25300b436c448622aa15","27":"31d6cfe0d16ae931b73c","28":"5d5301fb1e9ee2b862d8","29":"551e58cc658ea51353ff","30":"6a9a122d02edd16a7034","31":"3b588f0b0392a3140e12","32":"1c6d643c82918e2653ff","33":"5491656ee574e8b4a49d","34":"31d6cfe0d16ae931b73c","35":"3a33133d8b4cb1687191","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"3b5bbd7064a32e9c4378","40":"495c0b9853cb793a31ee","41":"046cb729bce8d0f74b9d","42":"31d6cfe0d16ae931b73c","43":"8f3a6c040b9deaeb92d0","44":"31d6cfe0d16ae931b73c","45":"d367ad35547de53e4d58","46":"ddb24ea7ffcfea2391aa","47":"cb30306a496b38be9101","48":"9da7acfafdc34e22f7b5","49":"f73ff81cf842ea909b56","50":"ca68f8fa1dd9edae64fc","51":"31d6cfe0d16ae931b73c","54":"a244c44843780ccefdea","55":"bd778f05e2c6a0cd3ebc","56":"bd778f05e2c6a0cd3ebc","57":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 401);
